import { calendarSettingsColumns } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Section = styled.section`
  display: grid;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: 0;
  margin: 0;
`;

export const Body = styled.div`
  ${calendarSettingsColumns};
`;

// Spans the account columns so the select lands in the visible-calendars track.
export const LabelCell = styled.div`
  grid-column: span 3;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;

// Runs past the remove column to the section edge — this row has nothing to remove.
export const Field = styled.div`
  grid-column: 4 / -1;
`;

export const Label = styled.label`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 0;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
    min-width: 1.6rem;
    flex-shrink: 0;
  }
`;
